import httpClient from "Api/httpClient";

const END_POINT = "/fe_parts";

const getFeParts = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getFePart = (part_id) => {
    if (!part_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + part_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printFePart = (part_id) => {
    if (!part_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?part_id=" + part_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createFeParts = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateFeParts = (payload, part_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + part_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteFeParts = (part_id) => {
    const DELETE_END_POINT = END_POINT + "/" + part_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const uploadFePartImage = (payload, part_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPLOAD_END_POINT = END_POINT + "/" + part_id + "/photo";
    return httpClient.post(UPLOAD_END_POINT, body);
};
const deleteFePartImage = (part_id, file_id) => {
    const DELETE_END_POINT = END_POINT + "/" + part_id + "/photo/" + file_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getFeParts, getFePart, printFePart, createFeParts, updateFeParts, deleteFeParts, uploadFePartImage, deleteFePartImage };
